<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="configName" :label="mPageType === 'ratingRules'?'客户评级':'客户档次'" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.configName" placeholder="请输入" v-trim />
      </a-form-item>
      <div style="display: flex; align-items: center; margin-top: 5px">
        <a-form-item name="min" :label="mPageType === 'ratingRules'?'评分区间':'成交额区间'" :rules="[{ required: true, message: '请输入' }]">
          <div style="display: flex; align-items: center; margin-top: 5px">
            <p style="width: 100px">大于:</p>
            <a-input-number v-model:value="editForm.min" :precision="0" :maxlength="10" placeholder="请输入" />
          </div>
        </a-form-item>
        <a-form-item
          name="max"
          label=""
          :rules="[{ required: true, message: '请输入' }]"
          style="margin: 5px 0 0 10px"
          class="down-box"
        >
          <div style="display: flex; align-items: center; margin-top: 5px">
            <p style="width: 100px">小于:</p>
            <a-input-number v-model:value="editForm.max" :precision="0" :maxlength="10" placeholder="请输入" />
          </div>
        </a-form-item>
      </div>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, watch } from 'vue'
import { ratingRulesSave, ratingRulesUpdate } from '@/api/gucangSales/ratingRules'
import type { FormInstance } from 'ant-design-vue'
import { RatingRulesSaveParams } from '@/typings/api/gucangSale'
import { message } from 'ant-design-vue'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const props = defineProps({
  pageType: {
    type: String,
    default: 'ratingRules'
  }
})
const mPageType = ref<string>()

watch(
  props,
  () => {
    mPageType.value = props.pageType
  },
  { immediate: true }
)
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<RatingRulesSaveParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: RatingRulesSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { configName, max, min } = editForm.value
    console.log('mPageType.value: ', mPageType.value)
    const p = {
      configName,
      max,
      min,
      logic: `>${editForm.value.min},≤${editForm.value.max}`,
      configType: mPageType.value === 'ratingRules' ? 2 : 1,
      appId: 'cos_fbu'
    }
    try {
      if (editForm.value.id) {
        await ratingRulesUpdate({ ...p, id: editForm.value.id })
      } else {
        await ratingRulesSave(p)
      }
      // toggle()
      loading.value = false
      visible.value = !visible.value
      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss" scoped>
:deep(.ant-form-item-with-help .ant-form-item-explain) {
  left: 70px !important;
}
</style>
